import React from "react";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import Button from "../component-lib/Molecules/button/Button";
import {
  CUSTOM_lABEL_STYLE,
  X_RAY_ORDER_DETAILS,
} from "../screens/patient-screen/visit-flow/constant";
import Heading from "../component-lib/Atoms/heading/EventEHRHeading";
import Input from "../component-lib/Atoms/Input/Input";
import useDeviceType from "../custom-hooks/DeviceType";
import { TEXT_CONSTANTS } from "../utils/text-constants/textConstants";

interface EKGOrderFormProps {
  getFormData: (data: any) => void;
}

export default function XRayOrderForm({ getFormData }: EKGOrderFormProps) {
  const deviceType = useDeviceType();

  const validationSchema = Yup.object().shape({
    [X_RAY_ORDER_DETAILS?.NOTES]: Yup.string().required("Notes is required"),
    [X_RAY_ORDER_DETAILS?.X_RAY_INFO]: Yup.string().required(
      "X-Ray of Body Part is required"
    ),
  });

  return (
    <Formik
      initialValues={{
        [X_RAY_ORDER_DETAILS?.NOTES]: "",
        [X_RAY_ORDER_DETAILS?.X_RAY_INFO]: "",
      }}
      validationSchema={validationSchema}
      enableReinitialize
      onSubmit={(values, { setSubmitting }) => {
        try {
          getFormData(values);
        } catch (error) {
          console.log(error);
        } finally {
          setSubmitting(false); // Reset submitting state
        }
      }}
    >
      {({
        errors,
        values,
        touched,
        isValid,
        dirty,
        setFieldValue,
        handleBlur,
        handleSubmit,
      }) => {
        return (
          <Form onSubmit={handleSubmit}>
            <div
              className="h-full flex flex-col justify-between gap-6"
              style={{
                height: deviceType === "mobile" ? "40vh" : "fit-content",
                overflow: "auto",
              }}
            >
              {/* NOTES */}
              <div>
                <Heading
                  title="X-Ray of Body Part"
                  customStyle={CUSTOM_lABEL_STYLE}
                />
                <Input
                  multiline={true}
                  rows={2}
                  // textFieldLabel="Enter Chief Complaint"
                  placeholder="Enter X-Ray of Body Part"
                  name={X_RAY_ORDER_DETAILS.X_RAY_INFO}
                  value={values[X_RAY_ORDER_DETAILS.X_RAY_INFO]}
                  onChangeCb={(e) => {
                    setFieldValue(
                      X_RAY_ORDER_DETAILS.X_RAY_INFO,
                      e.target.value
                    );
                  }}
                  onBlur={handleBlur}
                  size="small"
                  error={
                    touched[X_RAY_ORDER_DETAILS.X_RAY_INFO] &&
                    Boolean(errors[X_RAY_ORDER_DETAILS.X_RAY_INFO])
                  }
                  helperText={
                    touched[X_RAY_ORDER_DETAILS.X_RAY_INFO]
                      ? errors[X_RAY_ORDER_DETAILS.X_RAY_INFO]
                      : undefined
                  }
                />
              </div>
              {/* NOTES */}
              <div>
                <Heading
                  title={TEXT_CONSTANTS?.NOTES}
                  customStyle={CUSTOM_lABEL_STYLE}
                />
                <Input
                  multiline={true}
                  rows={2}
                  // textFieldLabel="Enter Chief Complaint"
                  placeholder={TEXT_CONSTANTS?.NOTES}
                  name={X_RAY_ORDER_DETAILS.NOTES}
                  value={values[X_RAY_ORDER_DETAILS.NOTES]}
                  onChangeCb={(e) => {
                    setFieldValue(X_RAY_ORDER_DETAILS.NOTES, e.target.value);
                  }}
                  onBlur={handleBlur}
                  size="small"
                  error={
                    touched[X_RAY_ORDER_DETAILS.NOTES] &&
                    Boolean(errors[X_RAY_ORDER_DETAILS.NOTES])
                  }
                  helperText={
                    touched[X_RAY_ORDER_DETAILS.NOTES]
                      ? errors[X_RAY_ORDER_DETAILS.NOTES]
                      : undefined
                  }
                />
              </div>
            </div>

            {/* ACTION BUTTON */}
            <div className="mt-9 text-end">
              <Button
                // disabled={!isValid} // Button disabled if form is invalid or submitting
                type="submit"
                label="Add Order"
                variant="contained"
                onClickCb={() => {}}
                style={{
                  padding: "8px 55px",
                  fontSize: "16px",
                }}
              ></Button>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}
